import { ValidatorService } from './../../../services/tools/validator.service';
import { Message1ModalComponent } from './../../tools/modals/message1-modal/message1-modal.component';
import { AutenticacionService } from './../../../services/autenticacion.service';
import { Component, OnInit, ViewChild } from '@angular/core';
import { RecuperarPasswordComponent } from '../recuperar-password/recuperar-password.component';
import { Router } from '@angular/router';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit {

  @ViewChild(RecuperarPasswordComponent) recuperarPasswordModal: RecuperarPasswordComponent;
  @ViewChild(Message1ModalComponent) message1Modal: Message1ModalComponent;
  public username: string;
  public password: string;
  public processing: boolean;
  public showPassword: boolean = false;

  constructor(private authService: AutenticacionService, private router: Router, private validatorService: ValidatorService) {
    this.processing = false;
  }

  ngOnInit() {
  }

  canLogin() {
    return (this.validatorService.required(this.username) && this.validatorService.required(this.password));
  }

  login() {

    if(!this.canLogin()) {
      return false;
    }

    this.processing = true;
    this.authService.login(this.username, this.password).subscribe(
      (response) => {
        const respuesta = response.json();
        if (respuesta.success) {
          console.log('redirecting');
          this.processing = false;
          this.authService.setUser(respuesta.content);
          this.router.navigate(['/']);
        }
      }, (error) => {
        this.processing = false;
        const content_error = error.json().content;
        let message = 'No se completó la acción. Por favor, intentelo más tarde.';
        if (error.status == 400 && (content_error.error == 'invalid_credentials' || content_error.username)) {
          message = 'El usuario y la contraseña ingresada no coinciden con nuestra base de datos, inténtelo nuevamente.';
        } else if (error.status == 400) {
          message = content_error.message;
        }
        this.message1Modal.open({
          'title': 'Información inválida',
          'message': message
        });
      }
    );
  } 

  recuperarPasswordMessage(message) {
    this.message1Modal.open({
      'title': 'Recuperar contraseña',
      'message': message
    });
  }

  recuperarPassword() {
    this.recuperarPasswordModal.open();
  }

  togglePasswordVisibility() {
    this.showPassword = !this.showPassword;
  }

}



// WEBPACK FOOTER //
// ./src/app/components/autenticacion/login/login.component.ts